var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentCyni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#FBFBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M57.9469 30.232C57.7826 23.013 51.8753 17.208 44.5973 17.208C43.2515 17.208 41.9522 17.4096 40.7242 17.7755C38.2713 14.8606 34.5936 13 30.4817 13C24.1433 13 18.8407 17.4034 17.4732 23.3138C17.3553 23.3138 17.2437 23.3076 17.1259 23.3076C9.74868 23.3076 3.77002 29.2738 3.77002 36.6355C3.77002 43.9972 9.75178 49.9635 17.1259 49.9635H52.4396C52.821 50.0069 53.2087 50.0317 53.6056 50.0317C59.3486 50.0317 64 45.3865 64 39.659C64 35.4758 61.5161 31.8756 57.9438 30.2351L57.9469 30.232Z",
    fill: "#6F92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M23.4022 39.2683C25.3527 39.2683 26.9342 37.69 26.9342 35.7457C26.9342 33.8014 25.3527 32.223 23.4022 32.223C21.4517 32.223 19.8702 33.8014 19.8702 35.7457C19.8702 37.69 21.4517 39.2683 23.4022 39.2683Z",
    fill: "#ED7B69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M44.3678 40.4499C46.3183 40.4499 47.8998 38.8715 47.8998 36.9272C47.8998 34.9829 46.3183 33.4045 44.3678 33.4045C42.4173 33.4045 40.8358 34.9829 40.8358 36.9272C40.8358 38.8715 42.4173 40.4499 44.3678 40.4499Z",
    fill: "#ED7B69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M38.8575 36.5984C41.3537 36.5984 43.3756 34.3254 43.3756 31.5191C43.3756 28.7127 41.3537 26.4397 38.8575 26.4397C36.3612 26.4397 34.3394 28.7127 34.3394 31.5191C34.3394 34.3254 36.3612 36.5984 38.8575 36.5984Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M41.1273 33.9347C42.3676 33.9347 43.3755 32.8525 43.3755 31.5222C43.3755 30.1919 42.3676 29.1096 41.1273 29.1096C39.8869 29.1096 38.8791 30.1919 38.8791 31.5222C38.8791 32.8525 39.8869 33.9347 41.1273 33.9347Z",
    fill: "#221714"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M28.308 36.5984C30.8043 36.5984 32.8261 34.3254 32.8261 31.5191C32.8261 28.7127 30.8043 26.4397 28.308 26.4397C25.8117 26.4397 23.7899 28.7127 23.7899 31.5191C23.7899 34.3254 25.8148 36.5984 28.308 36.5984Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M30.581 33.9347C31.8213 33.9347 32.8292 32.8525 32.8292 31.5222C32.8292 30.1919 31.8213 29.1096 30.581 29.1096C29.3406 29.1096 28.3328 30.1919 28.3328 31.5222C28.3328 32.8525 29.3406 33.9347 30.581 33.9347Z",
    fill: "#221714"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M25.5543 39.0452C27.5141 40.9337 30.1127 42.0872 32.8508 42.1058C35.589 42.1244 38.1876 40.9895 40.1009 39.0452C40.2404 38.9025 40.0234 38.6793 39.8776 38.825C38.0232 40.7104 35.5114 41.8174 32.8508 41.7988C30.1933 41.7802 27.6753 40.6577 25.7775 38.825C25.6349 38.6855 25.4116 38.9056 25.5574 39.0452H25.5543Z",
    fill: "#616161"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M31.9576 32.4399C31.9576 35.3921 29.5575 37.7829 26.6023 37.7829C23.647 37.7829 21.2469 35.389 21.2469 32.4399",
    stroke: "#616161",
    strokeWidth: 0.244976,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M21.2438 32.4402C21.2438 29.4881 23.644 27.0972 26.5992 27.0972C29.5544 27.0972 31.9546 29.4912 31.9546 32.4402",
    stroke: "#616161",
    strokeWidth: 0.244976,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M39.4898 37.7831C42.4481 37.7831 44.8452 35.3922 44.8452 32.4401C44.8452 29.488 42.4481 27.0972 39.4898 27.0972C36.5315 27.0972 34.1345 29.4911 34.1345 32.4401C34.1345 35.3891 36.5315 37.7831 39.4898 37.7831Z",
    stroke: "#616161",
    strokeWidth: 0.244976,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M31.9577 32.4399H34.1315",
    stroke: "#616161",
    strokeWidth: 0.244976,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentCyni);
export default __webpack_public_path__ + "static/media/comment-cyni.1a5467a5fc64d0a06dae9acfd0e487d2.svg";
export { ForwardRef as ReactComponent };